module.exports = __webpack_public_path__ + "assets/img/2.1f673425.jpg";